/**
 * PrivateKey
 */
export const PrivateKeyChange = (function () {

  var init = function () {
    addEventListeners();
  }

  function addEventListeners() {
    $('.myds-private-key-reset-form').on('submit', function (event) {
      // // Stop the form submitting
      event.preventDefault();
      event.stopPropagation();

      // Create a variable from this.  So that we can use it later on within the promise callback
      var form = this;

      // Validate the result and stop 
      if (!validate(form)) {
        return;
      }

      // Change the password and display the result
      var promise = patchChangePrivateKey(getInputs(form));
      promise.then(function () {
        Util.toggleAlert('.alert', "Success: Private Key Changed!", 'alert-success');
        resetForm(form);
      });
      promise.fail(function (response) {
        var message = (response.responseJSON != undefined) ? response.responseJSON['message'] : 'There was an error while processing this request.';
        Util.toggleAlert('.alert', message, 'alert-warning');
      });

    });
    // Toggles between showing and hiding password
    $(".show-hide-private-key-change a").on('click', function (event) {
      event.preventDefault();
      toggleInputVisibilityIcon( $('.eye-current-private-key'));
      toggleInputVisibility($('.show-hide-private-key-change input'));
    });

    $(".show-hide-private-key-confirm a").on('click', function (event) {
      event.preventDefault();
      toggleInputVisibilityIcon( $('.eye-confirm-private-key'));
      toggleInputVisibility( $('.show-hide-private-key-confirm input'));
    });
  }
  /**
   * Helper function to toggle the input visibility
   * @param {*} input 
   */
  function toggleInputVisibility(input) {
    if (input.attr('type') === 'password') {
      input.attr('type', 'text');
    } else {
      input.attr('type', 'password');
    }
  }
  /**
   * Helper function to toggle the input visibility icon
   * @param {*} input 
   */
  function toggleInputVisibilityIcon(icon) {
    icon.toggleClass('fa-eye-slash fa-eye');
  }

  /**
   * HTTP FUNCTIONS
   */
  function patchChangePrivateKey(data) {

    var csrf = Util.getCSRF();
    return $.ajax({
      url: '/private-key-change',
      type: 'patch',
      dataType: 'json',
      headers: {
        'x-csrf-token': csrf
      },
      data: data,
    });
  }

  /**
  * Validates the form checking that the inputs are correct and valid
  */
  function validate(form) {

    // Remove the was-validated class if it existed on the form.  This will clear the validation back to a blank slate
    $(form).removeClass('was-validated');

    var current_key = document.getElementById('myds-private-key-reset-current-private-key');
    var new_key = document.getElementById('myds-private-key-reset-new-private-key');
    var confirm_key = document.getElementById('myds-private-key-reset-confirm-private-key');

    // Check there are values and the min lengh is > 8
    // Note it should be possible to individually check constraints 
    var isValid = true;

    if ( current_key.validity.valueMissing ) {
      current_key.classList.add('is-invalid');
      isValid = false;
    }

    if (new_key.value.length < 8) {
      new_key.classList.add('is-invalid');
      confirm_key.classList.add('is-invalid');
      document.getElementById('myds-private-key-error-new-private-key').innerHTML = "Private key must be at least 8 characters in length.";
      document.getElementById('myds-private-key-error-confirm-private-key').innerHTML = "Private key must be at least 8 characters in length.";
      isValid = false;
    }

    // Displays an error if the new key does not match the confirmed key
    if (new_key.value != confirm_key.value) {
      // Set the styling and message for the error
      new_key.classList.add('is-invalid');
      confirm_key.classList.add('is-invalid');
      document.getElementById('myds-private-key-error-new-private-key').innerHTML = "The Private Key does not match";
      document.getElementById('myds-private-key-error-confirm-private-key').innerHTML = "The Private Key does not match";
      isValid = false;
    }
    if(isValid){
      $(form).toggleClass('was-validated');
    }
    
    return isValid;
  }

  /**
  * Get the values from the form and returns them in an object to be sent in the ajax request
  */
  function getInputs(form) {
    var current_key = document.getElementById('myds-private-key-reset-current-private-key').value;
    var new_key = document.getElementById('myds-private-key-reset-new-private-key').value;
    var confirm_key = document.getElementById('myds-private-key-reset-confirm-private-key').value;

    return {
      'key': current_key,
      'new_key': new_key,
      'new_key_confirmation': confirm_key
    }
  }

  /**
  * Reset the form values to be empty and removes the classes on the input boxes
  */
  function resetForm(form) {
    document.getElementById('myds-private-key-reset-new-private-key').value = "";
    document.getElementById('myds-private-key-reset-current-private-key').value = "";
    document.getElementById('myds-private-key-reset-confirm-private-key').value = "";

    var newKey = document.getElementById('myds-private-key-reset-new-private-key');
    var confirmKey = document.getElementById('myds-private-key-reset-confirm-private-key');

    newKey.innerHTML = "";
    confirmKey.innerHTML = "";
    newKey.classList.remove('is-invalid');
    confirmKey.classList.remove('is-invalid');

    $(form).removeClass('was-validated');
  }

  return {
    init: init
  }

}());


